import { motion } from "framer-motion";
import { Wind, Recycle, Droplets, Gauge, Flame, Rocket, Activity, Zap } from "lucide-react";
import Reveal from "@/components/motion/Reveal";

const ITEMS = [
  { icon: Gauge, title: "Öldruck-Fix", desc: "Zuverlässige Behebung von Öldruck-Themen – unsere Spezialität.", highlight: true },
  { icon: Rocket, title: "Stage 1–3 Abstimmungen", desc: "Von Stage 1 im Alltag bis zur kompromisslosen Stage 3." },
  { icon: Flame, title: "Pops & Bangs", desc: "Sound-Abstimmung für den sportlichen Auspuff-Klang." },
  { icon: Activity, title: "Leistungsmessung", desc: "Präzise Vorher-/Nachher-Messung auf dem DynoPro-Prüfstand." },
  { icon: Wind, title: "DPF / OPF-Lösungen", desc: "Diagnose und Lösungen rund um Diesel- & Ottopartikelfilter." },
  { icon: Recycle, title: "AGR-Lösungen", desc: "Lösungen bei Problemen und Fehlern der Abgasrückführung." },
  { icon: Droplets, title: "SCR / AdBlue", desc: "Diagnose und Lösungen rund um das SCR-/AdBlue-System." },
  { icon: Zap, title: "Launch Control & mehr", desc: "Weitere individuelle Software-Features auf Anfrage." },
];

export default function ExtraSolutions() {
  return (
    <section className="relative bg-[#050505] py-24 sm:py-28" data-testid="extra-solutions">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <Reveal className="mb-14 max-w-2xl">
          <p className="mb-4 flex items-center gap-3 font-body text-[11px] font-bold uppercase tracking-[0.3em] text-volt">
            <span className="h-px w-10 bg-volt" /> Mehr aus deinem Motor
          </p>
          <h2 className="font-heading text-4xl font-black uppercase leading-[0.9] tracking-tight text-white sm:text-5xl">
            Weitere Tuning-<span className="text-volt">Lösungen</span>
          </h2>
          <p className="mt-5 font-body text-base text-neutral-400">
            Neben klassischem Chiptuning bieten wir spezialisierte Lösungen rund um
            Motor, Abgassystem und Software – inklusive professioneller Leistungsmessung.
          </p>
        </Reveal>

        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {ITEMS.map((it, i) => (
            <motion.div
              key={it.title}
              initial={{ opacity: 0, y: 26 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: (i % 4) * 0.07 }}
              className={`border p-6 transition-colors ${
                it.highlight
                  ? "border-volt bg-volt/[0.06] hover:bg-volt/10"
                  : "border-white/10 bg-[#0d0d0d] hover:border-volt/40"
              }`}
            >
              <it.icon className={`h-7 w-7 ${it.highlight ? "text-volt" : "text-volt/80"}`} />
              <h3 className="mt-4 font-heading text-xl font-bold uppercase text-white">{it.title}</h3>
              <p className="mt-1.5 font-body text-sm text-neutral-400">{it.desc}</p>
            </motion.div>
          ))}
        </div>

        <Reveal delay={0.1}>
          <p className="mt-8 font-body text-xs text-neutral-600">
            Hinweis: Emissionsrelevante Eingriffe führen wir ausschließlich im gesetzlich
            zulässigen Rahmen bzw. für den Motorsport- und Export-Bereich durch.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
